import "./welcome.css";
import React, {useEffect, useRef} from "react";
import {useNavigate} from 'react-router-dom';
import RoutesToPages from "../../assets/RoutesToPages/Routes";
import {ReactComponent as WelcomeLogo} from "./img-welcome/logo.svg";

const WelcomePage = () => {
  const navigate = useNavigate();
  const welcomeContainerRef = useRef(null);
  const timerFadeIn = useRef(null);

  useEffect(() => {
    if (welcomeContainerRef.current) {
      welcomeContainerRef.current.classList.add('welcome-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      welcomeContainerRef.current.classList.remove('welcome-fade-in');
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);

  return (
    <div ref={welcomeContainerRef}
         className='welcome-container'>
      <WelcomeLogo className="welcome-logo"></WelcomeLogo>
      <p className='welcome-title'>Silné telo a <br/> vysoká nálada </p>
      <p className='welcome-subtitle'>Vydajte sa na cestu k zdraviu 🤸</p>
      <button className='btn-welcome'
              onClick={() => navigate(RoutesToPages.loginPage)}
      >Pokračovať
      </button>
    </div>
  )
}

export default WelcomePage;